/* Space & Sort — tiny UI helpers (no dependencies) */
(function () {
  'use strict';

  /* Scroll reveal */
  function initReveal() {
    var els = document.querySelectorAll('.ss-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ss-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ss-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Rotating promo messages in the utility bar */
  function initUtilRotation() {
    document.querySelectorAll('[data-ss-rotate]').forEach(function (wrap) {
      var msgs = wrap.querySelectorAll('.ss-util__msg');
      if (msgs.length < 2) return;
      var i = 0;
      var interval = parseInt(wrap.getAttribute('data-ss-rotate'), 10) || 4000;
      setInterval(function () {
        msgs[i].classList.remove('ss-util__msg--on');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('ss-util__msg--on');
      }, interval);
    });
  }

  /* Custom sort dropdown.
     A native <select>'s opened list is drawn by the OS and cannot be styled, so we keep
     the real <select> in the form (visually hidden, so Dawn's facet-filters-form logic and
     form submission are untouched) and drive it from a branded <details> menu: clicking an
     option sets select.value and fires a bubbling `change`, which is exactly what Dawn listens for. */
  function initSortDropdown() {
    document.querySelectorAll('select.facet-filters__sort').forEach(function (sel) {
      if (sel.dataset.ssSort === '1') return;
      sel.dataset.ssSort = '1';

      var wrap = document.createElement('details');
      wrap.className = 'ss-sort';

      var btn = document.createElement('summary');
      btn.className = 'ss-sort__btn';
      var label = document.createElement('span');
      label.className = 'ss-sort__current';
      var caret = document.createElement('span');
      caret.className = 'ss-sort__caret';
      caret.setAttribute('aria-hidden', 'true');
      btn.appendChild(label);
      btn.appendChild(caret);

      var panel = document.createElement('div');
      panel.className = 'ss-sort__panel';
      panel.setAttribute('role', 'listbox');

      function syncLabel() {
        var o = sel.options[sel.selectedIndex];
        label.textContent = o ? o.textContent.trim() : '';
        panel.querySelectorAll('.ss-sort__opt').forEach(function (b) {
          var on = b.getAttribute('data-value') === sel.value;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }

      Array.prototype.forEach.call(sel.options, function (opt) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ss-sort__opt';
        b.setAttribute('role', 'option');
        b.setAttribute('data-value', opt.value);
        b.textContent = opt.textContent.trim();
        b.addEventListener('click', function () {
          if (sel.value !== opt.value) {
            sel.value = opt.value;
            // Dawn's FacetFiltersForm binds to `input` on the form (facets.js), not `change`.
            // Setting .value programmatically fires neither, so dispatch both to be safe.
            sel.dispatchEvent(new Event('input', { bubbles: true }));
            sel.dispatchEvent(new Event('change', { bubbles: true }));
          }
          wrap.removeAttribute('open');
          syncLabel();
        });
        panel.appendChild(b);
      });

      wrap.appendChild(btn);
      wrap.appendChild(panel);
      sel.parentNode.insertBefore(wrap, sel);
      sel.classList.add('ss-sort__native');
      syncLabel();

      wrap.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { wrap.removeAttribute('open'); btn.focus(); }
      });
    });
  }

  /* close any open sort menu when clicking elsewhere */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('details.ss-sort[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  /* Dawn re-renders the facets/grid over AJAX, which wipes our markup — re-enhance. */
  function watchForSort() {
    if (!('MutationObserver' in window)) return;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; initSortDropdown(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function boot() { initReveal(); initUtilRotation(); initSortDropdown(); watchForSort(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
